<div class="messenger-container">
  <div class="messages-feed" messageAutoScroll observe-attributes="true">
    @if (messageQueue().length === 0) {
      <aiops-chat-welcome></aiops-chat-welcome>
    }
    <div class="messages-list">
      @if (messageQueue().length > 0) {
        @for (message of messageQueue(); track $index) {
          <aiops-message-block [message]="message"></aiops-message-block>
        }

        @if (agentTyping | async) {
          <div class="typing-indicator">
            <div class="typing-avatar">
              <div class="avatar-circle">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M11.667 1.16675H2.33366C1.69199 1.16675 1.16699 1.69175 1.16699 2.33341V12.8334L3.50033 10.5001H11.667C12.3087 10.5001 12.8337 9.97508 12.8337 9.33341V2.33341C12.8337 1.69175 12.3087 1.16675 11.667 1.16675ZM11.667 9.33341H3.50033L2.33366 10.5001V2.33341H11.667V9.33341Z"
                    fill="#005EB8"
                  />
                  <path
                    d="M7.44693 5.68234L6.78436 5.493C6.48599 5.40888 6.2142 5.24959 5.99499 5.03039C5.77579 4.81118 5.61651 4.53939 5.53239 4.24102L5.34305 3.57845C5.33352 3.55527 5.31732 3.53544 5.29651 3.52149C5.27569 3.50753 5.2512 3.50008 5.22614 3.50008C5.20108 3.50008 5.17658 3.50753 5.15576 3.52149C5.13495 3.53544 5.11875 3.55527 5.10923 3.57845L4.91989 4.24102C4.83577 4.53939 4.67648 4.81118 4.45728 5.03039C4.23807 5.24959 3.96628 5.40888 3.66791 5.493L3.00534 5.68234C2.9799 5.68956 2.95751 5.70488 2.94156 5.72598C2.92562 5.74708 2.91699 5.7728 2.91699 5.79925C2.91699 5.82569 2.92562 5.85141 2.94156 5.87251C2.95751 5.89361 2.9799 5.90893 3.00534 5.91615L3.66791 6.10549C3.96628 6.18961 4.23807 6.3489 4.45728 6.5681C4.67648 6.78731 4.83577 7.0591 4.91989 7.35747L5.10923 8.02004C5.11645 8.04548 5.13177 8.06787 5.15287 8.08382C5.17397 8.09976 5.19969 8.10839 5.22614 8.10839C5.25258 8.10839 5.2783 8.09976 5.2994 8.08382C5.3205 8.06787 5.33582 8.04548 5.34305 8.02004L5.53239 7.35747C5.61651 7.0591 5.77579 6.78731 5.99499 6.5681C6.2142 6.3489 6.48599 6.18961 6.78436 6.10549L7.44693 5.91615C7.47237 5.90893 7.49477 5.89361 7.51071 5.87251C7.52665 5.85141 7.53528 5.82569 7.53528 5.79925C7.53528 5.7728 7.52665 5.74708 7.51071 5.72598C7.49477 5.70488 7.47237 5.68956 7.44693 5.68234Z"
                    fill="#005EB8"
                  />
                  <path
                    d="M10.7357 4.31663L10.4044 4.22196C10.2553 4.1799 10.1194 4.10026 10.0098 3.99065C9.90015 3.88105 9.82051 3.74515 9.77845 3.59597L9.68378 3.26468C9.67902 3.25309 9.67092 3.24318 9.66051 3.2362C9.6501 3.22922 9.63786 3.2255 9.62533 3.2255C9.6128 3.2255 9.60055 3.22922 9.59014 3.2362C9.57973 3.24318 9.57163 3.25309 9.56687 3.26468L9.4722 3.59597C9.43014 3.74515 9.3505 3.88105 9.2409 3.99065C9.13129 4.10026 8.9954 4.1799 8.84621 4.22196L8.51493 4.31663C8.50221 4.32024 8.49101 4.3279 8.48304 4.33845C8.47507 4.349 8.47075 4.36186 8.47075 4.37508C8.47075 4.3883 8.47507 4.40117 8.48304 4.41172C8.49101 4.42226 8.50221 4.42993 8.51493 4.43354L8.84621 4.52821C8.9954 4.57027 9.13129 4.64991 9.2409 4.75951C9.3505 4.86911 9.43014 5.00501 9.4722 5.1542L9.56687 5.48548C9.57048 5.4982 9.57814 5.5094 9.58869 5.51737C9.59924 5.52534 9.6121 5.52965 9.62533 5.52965C9.63855 5.52965 9.65141 5.52534 9.66196 5.51737C9.67251 5.5094 9.68017 5.4982 9.68378 5.48548L9.77845 5.1542C9.82051 5.00501 9.90015 4.86911 10.0098 4.75951C10.1194 4.64991 10.2553 4.57027 10.4044 4.52821L10.7357 4.43354C10.7484 4.42993 10.7596 4.42226 10.7676 4.41172C10.7756 4.40117 10.7799 4.3883 10.7799 4.37508C10.7799 4.36186 10.7756 4.349 10.7676 4.33845C10.7596 4.3279 10.7484 4.32024 10.7357 4.31663Z"
                    fill="#005EB8"
                  />
                  <path
                    d="M9.1249 7.84001L8.92613 7.78321C8.83662 7.75797 8.75508 7.71019 8.68932 7.64442C8.62355 7.57866 8.57577 7.49712 8.55053 7.40761L8.49373 7.20884C8.49088 7.20189 8.48602 7.19594 8.47977 7.19175C8.47353 7.18757 8.46618 7.18533 8.45866 7.18533C8.45114 7.18533 8.44379 7.18757 8.43755 7.19175C8.4313 7.19594 8.42644 7.20189 8.42359 7.20884L8.36678 7.40761C8.34155 7.49712 8.29376 7.57866 8.228 7.64442C8.16224 7.71019 8.0807 7.75797 7.99119 7.78321L7.79242 7.84001C7.78479 7.84217 7.77807 7.84677 7.77329 7.8531C7.7685 7.85943 7.76592 7.86715 7.76592 7.87508C7.76592 7.88301 7.7685 7.89073 7.77329 7.89706C7.77807 7.90339 7.78479 7.90799 7.79242 7.91015L7.99119 7.96696C8.0807 7.99219 8.16224 8.03998 8.228 8.10574C8.29376 8.1715 8.34155 8.25304 8.36678 8.34255L8.42359 8.54132C8.42575 8.54895 8.43035 8.55567 8.43668 8.56045C8.44301 8.56524 8.45073 8.56782 8.45866 8.56782C8.46659 8.56782 8.47431 8.56524 8.48064 8.56045C8.48697 8.55567 8.49157 8.54895 8.49373 8.54132L8.55053 8.34255C8.57577 8.25304 8.62355 8.1715 8.68932 8.10574C8.75508 8.03998 8.83662 7.99219 8.92613 7.96696L9.1249 7.91015C9.13253 7.90799 9.13925 7.90339 9.14403 7.89706C9.14881 7.89073 9.1514 7.88301 9.1514 7.87508C9.1514 7.86715 9.14881 7.85943 9.14403 7.8531C9.13925 7.84677 9.13253 7.84217 9.1249 7.84001Z"
                    fill="#005EB8"
                  />
                </svg>
              </div>
            </div>
            <div class="typing-bubble">
              <div class="typing-dots">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
  <div class="chat-disclaimer">
    <p class="text-[0.625rem] text-[#64748B]">
      {{ 'CHAT_WELCOME.DISCLAIMER_PREFIX' | translate }}
      <a
        href="https://www.eaton.com/us/en-us/company/policies-and-statements/privacy-cookies-and-data-protection.html"
        target="_blank"
        rel="noopener noreferrer"
        class="text-[0.625rem] text-[#005EB8] font-semibold"
        >{{ 'CHAT_WELCOME.DISCLAIMER_LINK' | translate }}</a
      >.
    </p>
  </div>
  <div class="input-wrapper">
    <input
      class="message-input"
      [formControl]="msg"
      [attr.aria-label]="'MESSENGER.MESSAGE_ARIA' | translate"
      maxlength="2000"
      (keyup.enter)="sendMessage()"
      #messageInput
    />
    <div class="button-wrapper">
      <div class="char-counter">
        <span [class.counter-warning]="currentMsgCount > 1950"
          >{{ currentMsgCount }} / {{ maxCount }}</span
        >
      </div>

      <aiops-prompts-dialog></aiops-prompts-dialog>
      <span class="divider-span" aria-hidden="true"></span>
      <button
        type="button"
        class="send-button"
        (click)="sendMessage()"
        [disabled]="(agentLoading | async) || !(isConnected$ | async)"
        [class.loading]="agentLoading | async"
        [attr.aria-label]="
          (agentLoading | async)
            ? ('MESSENGER.SENDING_ARIA' | translate)
            : ('MESSENGER.SEND_ARIA' | translate)
        "
      >
        @if (agentLoading | async) {
          <svg
            class="spinner"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
          </svg>
        } @else {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <g opacity="0.6">
              <path
                d="M2.925 5.025L9.18333 7.70833L2.91667 6.875L2.925 5.025ZM9.175 12.2917L2.91667 14.975V13.125L9.175 12.2917ZM1.25833 2.5L1.25 8.33333L13.75 10L1.25 11.6667L1.25833 17.5L18.75 10L1.25833 2.5Z"
                fill="#475569"
              />
            </g>
          </svg>
        }
      </button>
    </div>
  </div>
</div>
